  import React, { useEffect, useState } from "react";
  import DashboardLayout from "../../../layouts/DashboardLayout";
  import { Button, Modal, Row, Tab, Tabs, Form } from "react-bootstrap";
  import axios from "axios";
  import "./index.css";
  import { toast } from "react-toastify";
  import Url from "../../../Api";

  interface UserProfilePreference {
    profileId: string;
    profileName: string;
    countryCode: string;
    isTarget: boolean;
    isBudget: boolean;
  }

  interface userListDataType {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    phone: string | null;
    status: string;
    createdOn: string;
    isProfileSelected: boolean;
    keywordStrategy: string | null;
    awsProfilePreferences?: UserProfilePreference[];
  }

  interface Profile {
    countryCode: string;
    isActive: boolean;
    profileId: string;
    profileName: string;
    timezone: string;
    type: "target" | "budget";
  }

  const Users: React.FC = () => {
    const [userStoredValue, setUserStoredValue] = useState<userListDataType[]>([]);
    const [profileOptions, setProfileOptions] = useState<Profile[]>([]);
    const [selectedTargetProfiles, setSelectedTargetProfiles] = useState<string[]>([]);
    const [selectedBudgetProfiles, setSelectedBudgetProfiles] = useState<string[]>([]);
    const [activeProfileTab, setActiveProfileTab] = useState<"target" | "budget">("target");

    const [showAddModal1, setShowAddModal1] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

    const [email, setEmail] = useState<string>("");
    const [pass, setPass] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const [passwordError, setPasswordError] = useState<string>("");

    const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
    const [editUserData, setEditUserData] = useState<userListDataType | null>(null);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
      userList();
      fetchTargetProfiles();
      fetchBudgetProfiles();
    }, []);

    const userList = () => {
      let userToken = localStorage.getItem("userToken");
      axios
        .get(Url.api + Url.usersAll, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        })
        .then((res) => {
          setUserStoredValue(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const fetchTargetProfiles = () => {
      const token = localStorage.getItem("userToken");
      axios
        .get("https://adsexpert-api.getgrowth.agency/Users/Profile", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          let profiles = res.data.result.awsProfilesPreferences || [];
          profiles = profiles.map((p: any) => ({ ...p, type: "target" }));
          setProfileOptions((prev) => {
            const budgetProfiles = prev.filter((p) => p.type === "budget");
            return [...budgetProfiles, ...profiles];
          });
          setSelectedTargetProfiles(profiles.map((p) => p.profileId));
        })
        .catch((err) => {
          toast.error("Failed to load target profiles");
          console.error(err);
        });
    };

    const fetchBudgetProfiles = () => {
      const token = localStorage.getItem("budgetOptimizer") || localStorage.getItem("token");
      axios
        .post(
          "https://budget-api.getgrowth.agency/api/amazon/ads/dashboard",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((res) => {
          if (res.status === 200 && res.data?.data) {
            const fetchedProfiles = res.data.data.map((profile: any) => ({
              profileId: String(profile.profileId),
              profileName: profile.name,
              countryCode: profile.countryCode,
              isActive: profile.isActive !== false,
              timezone: profile.timezone || "",
              type: "budget",
            }));
            setProfileOptions((prev) => {
              const targets = prev.filter((p) => p.type === "target");
              return [...targets, ...fetchedProfiles];
            });
            setSelectedBudgetProfiles(fetchedProfiles.map((b) => b.profileId));
          } else {
            toast.error("Failed to load budget profiles");
          }
        })
        .catch((error) => {
          console.error("Error fetching budget profiles:", error);
          toast.error("Failed to load budget profiles");
        });
    };

    const onTargetProfileToggle = (profileId: string) => {
      setSelectedTargetProfiles((prev) =>
        prev.includes(profileId) ? prev.filter((p) => p !== profileId) : [...prev, profileId]
      );
    };

    const onBudgetProfileToggle = (profileId: string) => {
      setSelectedBudgetProfiles((prev) =>
        prev.includes(profileId) ? prev.filter((p) => p !== profileId) : [...prev, profileId]
      );
    };

    // Merge profile selections with flags helper
    const mergeProfilesWithFlags = () => {
      const profileMap = new Map<
        string,
        {
          profileId: string;
          profileName: string;
          countryCode: string;
          isTarget: boolean;
          isBudget: boolean;
        }
      >();

      selectedTargetProfiles.forEach((profileId) => {
        const p = profileOptions.find((x) => x.profileId === profileId);
        if (!p) return;
        const pid = String(profileId);
        if (!profileMap.has(pid)) {
          profileMap.set(pid, {
            profileId: pid,
            profileName: p.profileName,
            countryCode: p.countryCode,
            isTarget: true,
            isBudget: false,
          });
        } else {
          profileMap.get(pid)!.isTarget = true;
        }
      });

      selectedBudgetProfiles.forEach((profileId) => {
        const p = profileOptions.find((x) => x.profileId === profileId);
        if (!p) return;
        const pid = String(profileId);
        if (!profileMap.has(pid)) {
          profileMap.set(pid, {
            profileId: pid,
            profileName: p.profileName,
            countryCode: p.countryCode,
            isTarget: false,
            isBudget: true,
          });
        } else {
          profileMap.get(pid)!.isBudget = true;
        }
      });

      return Array.from(profileMap.values());
    };

    // Register user call
    const registerCall = () => {
      if (!email || !pass) {
        toast.error("Email and password are required");
        return;
      }
      let userToken = localStorage.getItem("userToken");

      const reqData = {
        userName: name || email,
        email: email,
        password: pass,
        roleId: "649fd26a1e515ce10cd9254d",
        awsProfilePreferences: mergeProfilesWithFlags(),
      };

      axios
        .post(Url.api + Url.usersRegister, reqData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            setShowAddModal1(false);
            resetForm();
            userList();
          } else {
            toast.error(res.data.message || "Error registering user");
          }
        })
        .catch((error) => {
          console.log("Error registering user", error);
          toast.error("Something went wrong");
        });
    };

    const resetForm = () => {
      setEmail("");
      setPass("");
      setName("");
      setEmailError("");
      setPasswordError("");
      setSelectedTargetProfiles([]);
      setSelectedBudgetProfiles([]);
      setActiveProfileTab("target");
      setShowPassword(false);
    };

    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      setEmail(val);
      const gmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!gmailRegex.test(val)) setEmailError("*Please enter a valid email address.");
      else setEmailError("");
    };

    const validatePassword = (password: string) => {
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      return passwordRegex.test(password);
    };

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      setPass(val);
      if (!validatePassword(val))
        setPasswordError(
          "*Password must be at least 8 characters long, contain letters, numbers, and special characters."
        );
      else setPasswordError("");
    };

    // Open Edit Modal & pre-select profiles
    const openEditModal = (user: userListDataType) => {
      const fullName = [user.firstName, user.lastName].filter(Boolean).join(" ");
      setName(fullName || user.email || "");
      setEditUserData(user);
      setEmail(user.email);
      setPass("");
      setEmailError("");
      setPasswordError("");

      // Use UserProfilePreference type here
      const targetProfiles = (user.awsProfilePreferences || [])
        .filter((p) => p.isTarget)
        .map((p) => p.profileId);

      const budgetProfiles = (user.awsProfilePreferences || [])
        .filter((p) => p.isBudget)
        .map((p) => String(p.profileId));

      setSelectedTargetProfiles(targetProfiles);
      setSelectedBudgetProfiles(budgetProfiles);
      setActiveProfileTab("target");
      setShowEditModal(true);
    };

    // Handle Edit Submit
    const handleEditSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!editUserData) return;
    let userToken = localStorage.getItem("userToken");

    if (emailError || passwordError) {
      toast.error("Please fix form errors to submit");
      return;
    }

    const reqData = {
      id: editUserData.id,
      userName: name || email,
      firstName: name.split(" ") || "",
      lastName: name.split(" ").slice(1).join(" ") || "",
      email,
      password: pass,
      awsProfilePreferences: mergeProfilesWithFlags(), // Just like Add!
      isActive: true,
    };

    axios
      .put(Url.api + Url.usersPut + editUserData.id, reqData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
          userList();
          setShowEditModal(false);
          resetForm();
        } else toast.error(res.data.message);
      })
      .catch(() => toast.error("Something went wrong"));
  };


    // Toggle user status
    const toggleStatus = (id: string, currentStatus: boolean) => {
      const selectedUser = userStoredValue.find((user) => user.id === id);
      if (!selectedUser) return;
      setUserStoredValue((prevProfiles) =>
        prevProfiles.map((user) =>
          user.id === id ? { ...user, status: currentStatus ? "Inactive" : "Active" } : user
        )
      );
      editCall(id, !currentStatus, selectedUser);
    };

    // Edit call function
    const editCall = (id: string, status: boolean, userData: userListDataType) => {
      let userToken = localStorage.getItem("userToken");
      const reqData = {
        id: id,
        firstName: userData.firstName ?? "",
        lastName: userData.lastName ?? "",
        phone: userData.phone ?? "",
        isConnected: true,
        isProfileSelected: userData.isProfileSelected ?? true,
        keywordStrategy: userData.keywordStrategy ?? "",
      };
      axios
        .put(Url.api + Url.usersPut + id, reqData, {
          headers: { Authorization: `Bearer ${userToken}` },
        })
        .then((res) => {
          if (res.data.success) toast.success(res.data.message);
          else toast.error(res.data.message);
        })
        .catch(() => {
          toast.error("Something went wrong");
        });
    };

    // Delete user call
    const deleteApiCall = () => {
      if (!selectedUserId) return;
      let userToken = localStorage.getItem("userToken");
      axios
        .delete(Url.api + Url.usersDelete + selectedUserId, {
          headers: { Authorization: `Bearer ${userToken}` },
        })
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            setShowDeleteModal(false);
            userList();
            setSelectedUserId(null);
          } else {
            toast.error("Profile active error");
          }
        })
        .catch(() => {
          toast.error("Something went wrong");
        });
    };

    const splitListInTwo = <T,>(list: T[]): [T[], T[]] => {
      const half = Math.ceil(list.length / 2);
      return [list.slice(0, half), list.slice(half)];
    };

    // Filter active profiles by type
    const targetProfiles = profileOptions.filter(
      (p) => p.isActive && p.type === "target"
    );
    const budgetProfiles = profileOptions.filter(
      (p) => p.isActive && p.type === "budget"
    );

    const resetForm1 = () => {
      setEmail("");
      setPass("");
      setName("");
      setEmailError("");
      setPasswordError("");
      setSelectedTargetProfiles(targetProfiles.map((p) => p.profileId));
      setSelectedBudgetProfiles(budgetProfiles.map((p) => p.profileId));
      setActiveProfileTab("target");
      setShowPassword(false);
    };

    // Add User modal open handler that resets form before opening
    const openAddUserModal = () => {
      resetForm1();
      setShowAddModal1(true);
    };

    return (
      <DashboardLayout>
        <Row className="ms-2 me-3">
          <div className="profile-container mt-4">
            <div className="d-flex align-items-center justify-content-between mt-4">
              <form className="me-3 w-25">
                <div className="search-filter-container">
                  <i className="fa fa-search" aria-hidden="true"></i>
                  <input type="text" placeholder="Search" id="globalSearch" name="globalSearch" />
                </div>
              </form>
              <div>
                <Button
                  onClick={openAddUserModal}
                  className="btn btn-primary add-rules-btn pt-2 remove-button text-light"
                >
                  <i className="fa-regular fa-user"></i> Add User
                </Button>
              </div>
            </div>

            {/* Add New User Modal */}
            <Modal show={showAddModal1} onHide={() => setShowAddModal1(false)} size="lg" centered>
              <Modal.Header closeButton className="bg-light">
                <Modal.Title>Add New User</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (!emailError && !passwordError && email && pass) registerCall();
                    else toast.error("Please fix form errors before submitting");
                  }}
                >
                  <Form.Group>
                    <Form.Label>User Name</Form.Label>
                    <Form.Control placeholder="Enter your Name" onChange={(e) => setName(e.target.value)} value={name} />
                  </Form.Group>

                  <Form.Group className="mt-1">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      onChange={handleEmailChange}
                      value={email}
                      isInvalid={!!emailError}
                    />
                    <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mt-1">
                    <Form.Label>Password</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter a password"
                        onChange={handlePasswordChange}
                        value={pass}
                        isInvalid={!!passwordError}
                      />
                      <Button
                        variant="outline-secondary"
                        type="button"
                        className="input-group-text admin-user-icon"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? <i className="fa-solid fa-eye-slash"></i> : <i className="fa-solid fa-eye"></i>}
                      </Button>
                      <Form.Control.Feedback type="invalid">{passwordError}</Form.Control.Feedback>
                    </div>
                  </Form.Group>

                  <Tabs activeKey={activeProfileTab} onSelect={(k) => setActiveProfileTab(k as "target" | "budget")} className="mb-3">
                    <Tab eventKey="target" title="Target">
                      <div className="row" style={{ maxHeight: 200, overflowY: "auto", border: "1px solid #ddd", padding: 10 }}>
                        {(() => {
                          const [left, right] = splitListInTwo(targetProfiles);
                          return (
                            <>
                              <div className="col-6">
                                {left.map((profile) => (
                                  <div key={profile.profileId} className="form-check">
                                    <input
                                      type="checkbox"
                                      id={`target-profile-${profile.profileId}`}
                                      checked={selectedTargetProfiles.includes(profile.profileId)}
                                      onChange={() => onTargetProfileToggle(profile.profileId)}
                                      className="form-check-input"
                                    />
                                    <label htmlFor={`target-profile-${profile.profileId}`} className="form-check-label" style={{ fontSize: "14px", fontWeight: 400 }}>
                                      {`${profile.profileName} | ${profile.countryCode}`}
                                    </label>
                                  </div>
                                ))}
                              </div>
                              <div className="col-6">
                                {right.map((profile) => (
                                  <div key={profile.profileId} className="form-check">
                                    <input
                                      type="checkbox"
                                      id={`target-profile-${profile.profileId}-right`}
                                      checked={selectedTargetProfiles.includes(profile.profileId)}
                                      onChange={() => onTargetProfileToggle(profile.profileId)}
                                      className="form-check-input"
                                    />
                                    <label htmlFor={`target-profile-${profile.profileId}-right`} className="form-check-label" style={{ fontSize: "14px", fontWeight: 400 }}>
                                      {`${profile.profileName} | ${profile.countryCode}`}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </Tab>
                    <Tab eventKey="budget" title="Budget">
                      <div className="row" style={{ maxHeight: 200, overflowY: "auto", border: "1px solid #ddd", padding: 10 }}>
                        {(() => {
                          const [left, right] = splitListInTwo(budgetProfiles);
                          return (
                            <>
                              <div className="col-6">
                                {left.map((profile) => (
                                  <div key={profile.profileId} className="form-check">
                                    <input
                                      type="checkbox"
                                      id={`budget-profile-${profile.profileId}`}
                                      checked={selectedBudgetProfiles.includes(profile.profileId)}
                                      onChange={() => onBudgetProfileToggle(profile.profileId)}
                                      className="form-check-input"
                                    />
                                    <label htmlFor={`budget-profile-${profile.profileId}`} className="form-check-label" style={{ fontSize: "14px", fontWeight: 400 }}>
                                      {`${profile.profileName} | ${profile.countryCode}`}
                                    </label>
                                  </div>
                                ))}
                              </div>
                              <div className="col-6">
                                {right.map((profile) => (
                                  <div key={profile.profileId} className="form-check">
                                    <input
                                      type="checkbox"
                                      id={`budget-profile-${profile.profileId}-right`}
                                      checked={selectedBudgetProfiles.includes(profile.profileId)}
                                      onChange={() => onBudgetProfileToggle(profile.profileId)}
                                      className="form-check-input"
                                    />
                                    <label htmlFor={`budget-profile-${profile.profileId}-right`} className="form-check-label" style={{ fontSize: "14px", fontWeight: 400 }}>
                                      {`${profile.profileName} | ${profile.countryCode}`}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </Tab>
                  </Tabs>

                  <div className="admin-user-create text-center">
                    <Button className="btn btn-primary add-rules-btn pt-2 remove-button mt-4 text-light" type="submit">
                      Create
                    </Button>
                  </div>
                </form>
              </Modal.Body>
            </Modal>

            {/* Edit User Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered>
              <Modal.Header closeButton className="bg-light">
                <Modal.Title>Edit User</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {editUserData && (
                  <form onSubmit={handleEditSubmit}>
                    <Form.Group>
                      <Form.Label>User Name</Form.Label>
                      <Form.Control
                        placeholder="Enter your Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group className="mt-1">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={handleEmailChange}
                        isInvalid={!!emailError}
                      />
                      <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
                    </Form.Group>

                    {/* <Form.Group className="mt-1">
                      <Form.Label>Password</Form.Label>
                      <div className="position-relative d-flex">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter a password"
                          value={pass}
                          onChange={handlePasswordChange}
                          isInvalid={!!passwordError}
                        />
                        <Button
                          variant="outline-secondary"
                          type="button"
                          className="input-group-text admin-user-icon"
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? <i className="fa-solid fa-eye-slash"></i> : <i className="fa-solid fa-eye"></i>}
                        </Button>
                        <Form.Control.Feedback type="invalid">{passwordError}</Form.Control.Feedback>
                      </div>
                    </Form.Group> */}

                    <Tabs
                      activeKey={activeProfileTab}
                      onSelect={(k) => setActiveProfileTab(k as "target" | "budget")}
                      className="mb-3"
                    >
                      <Tab eventKey="target" title="Target">
                        <div
                          className="row"
                          style={{ maxHeight: 200, overflowY: "auto", border: "1px solid #ddd", padding: 10 }}
                        >
                          {(() => {
                            const [left, right] = splitListInTwo(targetProfiles);
                            return (
                              <>
                                <div className="col-6">
                                  {left.map((profile) => (
                                    <div key={profile.profileId} className="form-check">
                                      <input
                                        type="checkbox"
                                        id={`target-profile-edit-${profile.profileId}`}
                                        checked={selectedTargetProfiles.includes(profile.profileId)}
                                        onChange={() => onTargetProfileToggle(profile.profileId)}
                                        className="form-check-input"
                                      />
                                      <label
                                        htmlFor={`target-profile-edit-${profile.profileId}`}
                                        className="form-check-label"
                                        style={{ fontSize: "14px", fontWeight: 400 }}
                                      >
                                        {`${profile.profileName} | ${profile.countryCode}`}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                                <div className="col-6">
                                  {right.map((profile) => (
                                    <div key={profile.profileId} className="form-check">
                                      <input
                                        type="checkbox"
                                        id={`target-profile-edit-right-${profile.profileId}`}
                                        checked={selectedTargetProfiles.includes(profile.profileId)}
                                        onChange={() => onTargetProfileToggle(profile.profileId)}
                                        className="form-check-input"
                                      />
                                      <label
                                        htmlFor={`target-profile-edit-right-${profile.profileId}`}
                                        className="form-check-label"
                                        style={{ fontSize: "14px", fontWeight: 400 }}
                                      >
                                        {`${profile.profileName} | ${profile.countryCode}`}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              </>
                            );
                          })()}
                        </div>
                      </Tab>
                      <Tab eventKey="budget" title="Budget">
                        <div
                          className="row"
                          style={{ maxHeight: 200, overflowY: "auto", border: "1px solid #ddd", padding: 10 }}
                        >
                          {(() => {
                            const [left, right] = splitListInTwo(budgetProfiles);
                            return (
                              <>
                                <div className="col-6">
                                  {left.map((profile) => (
                                    <div key={profile.profileId} className="form-check">
                                      <input
                                        type="checkbox"
                                        id={`budget-profile-edit-${profile.profileId}`}
                                        checked={selectedBudgetProfiles.includes(profile.profileId)}
                                        onChange={() => onBudgetProfileToggle(profile.profileId)}
                                        className="form-check-input"
                                      />
                                      <label
                                        htmlFor={`budget-profile-edit-${profile.profileId}`}
                                        className="form-check-label"
                                        style={{ fontSize: "14px", fontWeight: 400 }}
                                      >
                                        {`${profile.profileName} | ${profile.countryCode}`}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                                <div className="col-6">
                                  {right.map((profile) => (
                                    <div key={profile.profileId} className="form-check">
                                      <input
                                        type="checkbox"
                                        id={`budget-profile-edit-right-${profile.profileId}`}
                                        checked={selectedBudgetProfiles.includes(profile.profileId)}
                                        onChange={() => onBudgetProfileToggle(profile.profileId)}
                                        className="form-check-input"
                                      />
                                      <label
                                        htmlFor={`budget-profile-edit-right-${profile.profileId}`}
                                        className="form-check-label"
                                        style={{ fontSize: "14px", fontWeight: 400 }}
                                      >
                                        {`${profile.profileName} | ${profile.countryCode}`}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              </>
                            );
                          })()}
                        </div>
                      </Tab>
                    </Tabs>

                    <div className="admin-user-create text-center">
                      <Button
                        className="btn btn-primary add-rules-btn pt-2 remove-button mt-4 text-light"
                        type="submit"
                      >
                        Save Changes
                      </Button>
                    </div>
                  </form>
                )}
              </Modal.Body>
            </Modal>

            {/* User Listing Table */}
            <table className="table table-hover mt-4 table-light">
              <thead className="admin-user-table-head">
                <tr>
                  <th>Email</th>
                  <th>Created On</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="admin-user-table-body">
                {userStoredValue.map((val) => (
                  <tr key={val.id}>
                    <td>{val.email}</td>
                    <td>{val.createdOn}</td>
                    <td>
                      <label className="toggle-switch">
                        <input
                          type="checkbox"
                          checked={val.status === "Active"}
                          onChange={() => toggleStatus(val.id, val.status === "Active")}
                        />
                        <span className="slider"></span>
                      </label>
                    </td>
                    <td>
                      <button
                        className="action-icon-btn"
                        title="Edit"
                        aria-label="Edit"
                        style={{ color: "#18a8e0", fontSize: "20px" }}
                        onClick={() => openEditModal(val)}
                      >
                        <i className="fa fa-pencil-square-o"></i>
                      </button>

                      <button
                        className="action-icon-btn"
                        title="Delete"
                        aria-label="Delete"
                        style={{ color: "#ed2136", fontSize: "20px" }}
                        onClick={() => {
                          setSelectedUserId(val.id);
                          setShowDeleteModal(true);
                        }}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Confirm User Delete Modal */}
            <Modal
              show={showDeleteModal}
              onHide={() => setShowDeleteModal(false)}
              centered
              className="admin-user-custom-modal"
            >
              <Modal.Header closeButton className="admin-user-custom-modal-header">
                <h6>Confirm User Deletion</h6>
              </Modal.Header>
              <Modal.Body className="admin-user-custom-modal-body">
                <h6>Are you sure? This will permanently delete the user?</h6>
              </Modal.Body>
              <Modal.Footer className="justify-content-center border-0">
                <Button variant="secondary" className="admin-profile-popup-cancel" onClick={() => setShowDeleteModal(false)}>
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary add-rules-btn pt-2 remove-button text-light"
                  variant="primary"
                  onClick={deleteApiCall}
                >
                  Confirm
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </Row>
      </DashboardLayout>
    );
  };

  export default Users;